import Layout from '@/components/feature/Layout';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import LatestMovies from './components/LatestMovies';
import PopularList from './components/PopularList';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <Layout>
      <HeroCarousel />
      <CategoryEntry />
      <LatestMovies />
      <PopularList />
      <SiteIntro />
    </Layout>
  );
}